import { Callable } from '@prophecy/interfaces/generic';

export function isDependencySame(
  dependency: unknown[],
  lastDependency: unknown[],
  equalityFunction: (a: unknown, b: unknown) => boolean = Object.is
) {
  if (dependency.length !== lastDependency.length) {
    return false;
  }

  for (let i = 0; i < dependency.length; i++) {
    if (!equalityFunction(dependency[i], lastDependency[i])) {
      return false;
    }
  }

  return true;
}

export function memoize(equalityFunction?: (a: unknown, b: unknown) => boolean) {
  let lastDependency: unknown[] | null = null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let lastResult: any = null;

  function memoizedFunction<T extends Callable>(fn: T, dependency: unknown[]): ReturnType<T> {
    if (lastDependency && isDependencySame(dependency, lastDependency, equalityFunction)) {
      return lastResult;
    }

    lastDependency = dependency;
    lastResult = fn();
    return lastResult;
  }

  return memoizedFunction;
}
